var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1505_12456)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8333 17.0013V15.9346C31.8333 14.4412 31.8333 13.6944 31.5427 13.124C31.287 12.6222 30.8791 12.2143 30.3773 11.9586C29.8069 11.668 29.0601 11.668 27.5667 11.668H25.4333C23.9399 11.668 23.1931 11.668 22.6227 11.9586C22.1209 12.2143 21.713 12.6222 21.4573 13.124C21.1667 13.6944 21.1667 14.4412 21.1667 15.9346V17.0013M23.8333 24.3346V31.0013M29.1667 24.3346V31.0013M14.5 17.0013H38.5M35.8333 17.0013V31.9346C35.8333 34.1748 35.8333 35.295 35.3974 36.1506C35.0139 36.9032 34.4019 37.5152 33.6493 37.8987C32.7936 38.3346 31.6735 38.3346 29.4333 38.3346H23.5667C21.3265 38.3346 20.2064 38.3346 19.3507 37.8987C18.5981 37.5152 17.9861 36.9032 17.6026 36.1506C17.1667 35.295 17.1667 34.1748 17.1667 31.9346V17.0013",
    stroke: "#B40000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1505_12456",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1505_12456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1505_12456",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSquare);
export default __webpack_public_path__ + "static/media/trashSquare.f16497f7ca9bd0699d0693fc26f97b53.svg";
export { ForwardRef as ReactComponent };